import { useState, useEffect } from 'react';
import { fetchPatients } from '../services/api';

const useApiPatients = () => {
  const [apiPatients, setApiPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadPatients = () => {
    setLoading(true);
    setError(null);
    fetchPatients()
      .then(data => {
        // Handle both array response and wrapped response
        const list = Array.isArray(data) ? data : (data.patientDetails ? [data.patientDetails] : []);
        setApiPatients(list);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => { loadPatients(); }, []);

  return { apiPatients, loading, error, refetch: loadPatients };
};

export default useApiPatients;